import React from "react";
import PropTypes from "prop-types";
import Link from "@mui/material/Link";
import { Colors } from "../../constants/colors";

const SFLink = ({
  href,
  underline,
  color,
  variant,
  children,
  ...otherProps
}) => {
  return (
    <Link
      {...(href && { href })}
      underline={underline}
      color={Colors[color.toLocaleUpperCase()] ?? Colors.BLUE400}
      variant={variant}
      {...otherProps}
    >
      {children}
    </Link>
  );
};

SFLink.defaultProps = {
  color: "blue400",
  variant: "textLink",
  underline: "always",
};

SFLink.propTypes = {
  color: PropTypes.string,
  variant: PropTypes.string,
  underline: PropTypes.oneOf(["always", "hover", "none"]),
};

export default SFLink;
